import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { supabase } from '../supabaseClient'

export function usePageView() {
  const location = useLocation()

  useEffect(() => {
    const track = async () => {
      try {
        await supabase.functions.invoke('track', {
          body: {
            path: location.pathname + location.search,
            referrer: document.referrer,
            userAgent: navigator.userAgent,
          }
        })
      } catch {
        // fail silently — analytics should not break UX
      }
    }
    track()
  }, [location])
}
